export default defineNuxtPlugin(() => {
    const carrelloStore = useCarrelloStore()
    // Calcola i prezzi all'inizializzazione
    carrelloStore.calcolaPrezzi()
})